export default __webpack_public_path__ + "static/media/kitAlarma1Mobile.f7770202.png";